import { Injectable } from "@angular/core";
import { StatusCodes } from "@obg/ngx.global";
import { Observable } from "rxjs";

import { CoreHttpClient } from "../../http-client/http-client.service";

import { DepositLimitConfigService } from "./deposit-limit.config";
import {
	DepositLimit,
	DepositLimitParams,
	DepositLimits,
	DepositLimitType,
	DepositLimitUnconfirmedParams,
} from "./deposit-limit.model";

/**
 * @deprecated [fabric-deprecated] - Use DepositLimitService from app-responsible-gaming instead
 */
@Injectable({
	providedIn: "root",
})
export class DepositLimitService {
	private depositLimitTypeUrlParam = ":depositLimitType";

	constructor(
		private httpClient: CoreHttpClient,
		private config: DepositLimitConfigService
	) {}

	/**
	 * @deprecated [fabric-deprecated] - Use ResponsibleGamingAppCommand.GetAllDepositLimits instead
	 */
	getAll(): Observable<DepositLimits> {
		return this.httpClient.get<DepositLimits>({
			url: this.config.getDepositLimitEndpoint(),
			suppressErrorLogging: [StatusCodes.Unauthorized],
		});
	}

	/**
	 * @deprecated [fabric-deprecated] - Use ResponsibleGamingAppCommand.UpdateDepositLimit instead
	 */
	update(params: DepositLimitParams): Observable<DepositLimit> {
		return this.httpClient.put<DepositLimit>({
			url: `${this.config.getDepositLimitEndpoint()}/${this.depositLimitTypeUrlParam}`,
			data: params,
		});
	}

	/**
	 * @deprecated [fabric-deprecated] - Use ResponsibleGamingAppCommand.RemoveDepositLimit instead
	 */
	remove(depositLimitType: DepositLimitType): Observable<DepositLimit> {
		return this.httpClient.delete<DepositLimit>({
			url: `${this.config.getDepositLimitEndpoint()}/${this.depositLimitTypeUrlParam}`,
			data: { depositLimitType },
		});
	}

	/**
	 * @deprecated [fabric-deprecated] - Use ResponsibleGamingAppCommand.GetUnconfirmedDepositLimits instead
	 */
	getUnconfirmed(): Observable<DepositLimits> {
		return this.httpClient.get<DepositLimits>({ url: this.config.getUnconfirmedDepositLimitEndpoint() });
	}

	/**
	 * @deprecated [fabric-deprecated] - Use ResponsibleGamingAppCommand.AcceptUnconfirmedDepositLimit instead
	 */
	acceptUnconfirmed(params: DepositLimitUnconfirmedParams): Observable<void> {
		return this.httpClient.put<void>({
			url: this.config.getUnconfirmedDepositLimitEndpoint(),
			data: params,
		});
	}

	/**
	 * @deprecated [fabric-deprecated] - Use ResponsibleGamingAppCommand.DeclineUnconfirmedDepositLimit instead
	 */
	declineUnconfirmed(params: DepositLimitUnconfirmedParams): Observable<void> {
		return this.httpClient.delete<void>({
			url: this.config.getUnconfirmedDepositLimitEndpoint(),
			data: params,
		});
	}
}
